import { StateHelpers } from './helpers/state-helpers';
export class CountryStateSelector {
	constructor() {
		const countryStateSelectors = document.querySelectorAll('.country-state-selector');

		countryStateSelectors?.forEach(selector => {
			const stateFilterDropdown = selector.querySelector(".state-filter") as HTMLSelectElement;
			const countryFilterDropDown = selector.querySelector(".country-filter") as HTMLSelectElement;
			const usCountyFilterDropDown = selector.querySelector(".county-filter") as HTMLSelectElement;
			//const ukCountyFilterDropDown = selector.querySelector(".uk-county-filter") as HTMLSelectElement;



			countryFilterDropDown?.addEventListener('change',
				() => {
					const country = countryFilterDropDown.value;
					stateFilterDropdown.value = "";
					if (usCountyFilterDropDown) {
						usCountyFilterDropDown.value = "";
					}
					const supportedCountriesWithState = ["USA", "Canada", "UnitedKingdom"];
					if (supportedCountriesWithState.includes(country)) {
						stateFilterDropdown.classList.remove('d-none');
						stateFilterDropdown.querySelectorAll('option').forEach(o => o.remove());
						let states: any[] = [];
						
						if (country === "USA") {
							states = window.usStates;
							stateFilterDropdown.append(new Option("Select State", ""));
							states.forEach((s: any) => {
								stateFilterDropdown.append(new Option(s.stateDisplayName, s.stateCode));
							});
						} else if (country === "UnitedKingdom") {
							usCountyFilterDropDown?.classList.add('d-none');
							const ukCounties = window.ukCounties as string[];
							stateFilterDropdown.append(new Option("Select County", ""));
							ukCounties.forEach((s) => {
								stateFilterDropdown.append(new Option(s, s));
							});
						} else {
							usCountyFilterDropDown?.classList.add('d-none');
							states = window.caProvinces as any[];
							stateFilterDropdown.append(new Option("Select Province", ""));
							states.forEach((s) => {
								stateFilterDropdown.append(new Option(s.stateDisplayName, s.stateName));
							});
						}
					} else {
						stateFilterDropdown.classList.add('d-none');
						usCountyFilterDropDown?.classList.add('d-none');
					}
				});
			
			stateFilterDropdown?.addEventListener('change', () => {				
				if (usCountyFilterDropDown) {
					usCountyFilterDropDown.classList.add('d-none');				
					
					if (countryFilterDropDown.value === 'Canada') {
						const selectedProvince = window.caProvinces.find(a=>a.stateName === stateFilterDropdown.value);
						if (selectedProvince.districts){

							let districts = selectedProvince.districts as any[];
							usCountyFilterDropDown.querySelectorAll('option').forEach(o => o.remove());
							usCountyFilterDropDown.append(new Option("Select Division", ""));
							districts.forEach((c) => {
								usCountyFilterDropDown.append(new Option(c.name, c.itemGUID));
							});
							if (districts.length > 0) {
								usCountyFilterDropDown.classList.remove('d-none');
							}
							return;
						}						
						
						return;
					}
					
					let stateCode = stateFilterDropdown.value;
					if (stateCode.length > 2) {
						stateCode = StateHelpers.getStateCodeFromName(stateCode);
					}
					const counties = window.usCounties.filter(s=> s.stateAbbr === stateCode);
					usCountyFilterDropDown.querySelectorAll('option').forEach(o => o.remove());
					usCountyFilterDropDown.append(new Option("Select County", ""));
					counties.forEach((c) => {
						usCountyFilterDropDown.append(new Option(c.countyName, c.itemGUID));
					});
					if (counties.length > 0) {
						usCountyFilterDropDown.classList.remove('d-none');
					}
				}
			})
			
		});
	}
}